import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { ListSearch } from '@fry/lib/list';


@Injectable()
export class RolesSearch implements ListSearch {

  private fulltext() {
    return of({
      id: 'fulltext',
      label: '',
      filter: (item, value): Observable<boolean> => {
        const text = `${item.doc.title.toLowerCase()} ${item.doc._id.toLowerCase()}`;
        return of(text.indexOf(value.toLowerCase()) !== -1);
      },
      featured: true,
      widget: {
        type: 'string',
        placeholder: $localize `Full text search`,
      }
    });
  }

  private nofulltext() {
    const flt = {
      id: 'nofulltext',
      label: $localize `Exclude Full text search`,
      filter: (item, value) => {
        return of(item.doc.title.toLowerCase().indexOf(value.toLowerCase()) === -1);
      },
      widget: {
        type: 'string'
      }
    };

    return of(flt);
  }

  public filters() {
    const _filters = [
      this.fulltext(),
      this.nofulltext()
    ];

    return forkJoin(_filters);
  }

  public sorts() {
    return of([
      {
        id: 'title',
        name: $localize `Title`,
        sort: (itemA, itemB) => {
          return itemA.title.toLowerCase() > itemB.title.toLowerCase() ? 1 : -1;
        }
      }
    ]);
  }
}
